var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_15187_44150)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7977 128.841C53.3581 127.61 52.7924 126.153 51.556 125.595C50.3195 125.037 48.8634 125.583 48.303 126.814C47.7426 128.045 48.2839 129.512 49.5204 130.069C50.7568 130.627 52.2373 130.071 52.7977 128.84V128.841Z",
    fill: "url(#paint1_linear_15187_44150)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6024 132.491C66.959 131.708 66.5992 130.78 65.8127 130.425C65.0263 130.07 64.0987 130.418 63.7421 131.202C63.3855 131.985 63.7304 132.919 64.5169 133.274C65.3033 133.63 66.2458 133.276 66.6024 132.492V132.491Z",
    fill: "url(#paint2_linear_15187_44150)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8524 58.6789C21.209 57.8958 20.8492 56.9679 20.0627 56.6128C19.2763 56.2577 18.3487 56.6054 17.9921 57.3896C17.6355 58.1727 17.9804 59.1069 18.7669 59.462C19.5533 59.8171 20.4958 59.463 20.8524 58.6799V58.6789Z",
    fill: "url(#paint3_linear_15187_44150)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3524 132.491C59.709 131.708 59.3492 130.78 58.5627 130.425C57.7763 130.07 56.8487 130.418 56.4921 131.202C56.1355 131.985 56.4804 132.919 57.2669 133.274C58.0533 133.63 58.9958 133.276 59.3524 132.492V132.491Z",
    fill: "url(#paint4_linear_15187_44150)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.875 43.4936C124.76 42.4685 124.628 40.9108 123.598 40.0305C122.569 39.1502 121.017 39.2675 120.133 40.2926C119.249 41.3177 119.355 42.8765 120.385 43.7578C121.414 44.6382 122.992 44.5187 123.877 43.4936H123.875Z",
    fill: "url(#paint5_linear_15187_44150)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.575 48.665C129.137 48.0119 129.053 47.0217 128.399 46.4606C127.743 45.9004 126.756 45.9755 126.193 46.6275C125.631 47.2806 125.698 48.2719 126.353 48.8331C127.009 49.3932 128.013 49.3171 128.576 48.665H128.575Z",
    fill: "url(#paint6_linear_15187_44150)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3403 41.04C31.2244 40.0149 31.0928 38.4572 30.0633 37.5769C29.0338 36.6966 27.4822 36.8139 26.5981 37.839C25.714 38.8641 25.8201 40.4229 26.8496 41.3042C27.8791 42.1846 29.4573 42.0651 30.3413 41.04H30.3403Z",
    fill: "url(#paint7_linear_15187_44150)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8349 49.9359C25.0537 48.5228 24.8722 46.3753 23.453 45.1618C22.0338 43.9482 19.8948 44.1099 18.676 45.5231C17.4573 46.9362 17.6036 49.0851 19.0228 50.3002C20.442 51.5137 22.6176 51.3491 23.8364 49.9359H23.8349Z",
    fill: "url(#paint8_linear_15187_44150)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 47.7,
    fill: "url(#paint9_linear_15187_44150)",
    stroke: "#FF7788",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.0014,
    cy: 73.9999,
    r: 34.56,
    fill: "url(#paint10_linear_15187_44150)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7282 94.2641C79.7282 97.4244 77.1523 99.9999 73.9916 99.9999C70.8308 99.9999 68.2812 97.4244 68.2812 94.2641C68.2812 91.1038 70.8383 88.5283 73.9916 88.5283C77.1448 88.5283 79.7282 91.1038 79.7282 94.2641Z",
    fill: "#E20D27"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3493 53.2746L79.007 79.0106C78.8683 81.6797 76.6674 83.7678 73.9941 83.7678C71.3207 83.7678 69.1348 81.6797 68.9961 79.0106L67.6538 53.2746C67.5226 50.3655 69.8097 48 72.6668 48H75.3364C78.1934 48 80.4805 50.3655 80.3493 53.2746Z",
    fill: "#E20D27"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15187_44150",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9EBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15187_44150",
    x1: 50.5482,
    y1: 125.376,
    x2: 50.5482,
    y2: 130.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15187_44150",
    x1: 65.171,
    y1: 130.286,
    x2: 65.171,
    y2: 133.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15187_44150",
    x1: 19.421,
    y1: 56.4736,
    x2: 19.421,
    y2: 59.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15187_44150",
    x1: 57.921,
    y1: 130.286,
    x2: 57.921,
    y2: 133.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15187_44150",
    x1: 121.999,
    y1: 39.4399,
    x2: 121.999,
    y2: 44.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15187_44150",
    x1: 127.38,
    y1: 46.085,
    x2: 127.38,
    y2: 49.2082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15187_44150",
    x1: 28.4638,
    y1: 36.9863,
    x2: 28.4638,
    y2: 41.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15187_44150",
    x1: 21.248,
    y1: 44.3477,
    x2: 21.248,
    y2: 51.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4E0E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15187_44150",
    x1: 39.44,
    y1: 37.52,
    x2: 111.44,
    y2: 114.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15187_44150",
    x1: 50.0014,
    y1: 48.0799,
    x2: 95.1214,
    y2: 101.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.18a0983402eda03adf6dbfcb3ff197e9.svg";
export { ForwardRef as ReactComponent };